define('models/pages/dashboard/index',[
    'models/base/model',
    'models/base/collection',

    'models/pages/dashboard/balance',
    'models/pages/dashboard/news',
    'models/pages/dashboard/notifies',
    'models/pages/dashboard/sessions',

    'lib/utils'
], function(
    Model, Collection,
    BalanceModel,
    NewsModel,
    NotifiesModel,
    SessionsModel
) {
    'use strict';

    var DashboardPageModel = Model.extend({
        urlPath: '/pages/dashboard',
        defaults: {
        },
        constructor: function() {
            Model.apply(this, arguments);
            // this.items = new Collection(data ? data.items : [], { parse: true });

            this.news = new NewsModel();
            this.balance = new BalanceModel();
            this.notifies = new NotifiesModel();
            this.sessions = new SessionsModel();

            this.on('beforeLoad', function() {
                this.news.items.beginSync();
                // this.balance.items.beginSync();
                this.notifies.items.beginSync();
                this.sessions.items.beginSync();
            });

            this.on('afterLoad', function() {
                this.news.items.finishSync();
                //this.balance.items.finishSync();
                this.notifies.items.finishSync();
                this.sessions.items.finishSync();
            });
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.news.dispose();
            this.balance.dispose();
            this.notifies.dispose();
            this.sessions.dispose();

            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            this.news.set(this.news.parse(data.news));
            this.balance.set(this.balance.parse(data.balance));
            this.notifies.set(this.notifies.parse(data.notifies));
            this.sessions.set(this.sessions.parse(data.sessions));

            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            return params;
        }
    });

    return DashboardPageModel;
});
